import React from 'react';

/** Turns `**value**` in catalog strings into `<strong>` nodes. */
export const format = (text: string): React.ReactNode => {
  const parts = text.split(/\*\*(.+?)\*\*/g);
  if (parts.length === 1) {
    return text;
  }

  return parts.map((part, index) => (index % 2 === 1 ? <strong key={index}>{part}</strong> : part));
};
